<template>
  <div class="float-btn-group">
    <div class="btn-item btn1">
      <a :href="'tel:'+websiteConfig.customerServicePhone">
        <el-image class="icon" :src="require('@/assets/layout/rexiandianhua.png')"></el-image>
        <span>热线电话</span>
        <div class="phone">{{ websiteConfig.customerServicePhone }}</div>
      </a>
    </div>
    <div class="btn-item btn2">
      <el-image class="icon" :src="require('@/assets/layout/yewuzixun.png')"></el-image>
      <span>微信客服</span>
      <div class="qrcode">
        <el-image :src="websiteConfig.businessAskQrcode"></el-image>
      </div>
    </div>
    <div class="btn-item" @click="$router.push('/inquiry')">
      <el-image class="icon" :src="require('@/assets/layout/kuaisuchaxun.png')"></el-image>
      <span>快速查询</span>
    </div>
    <div class="btn-item" @click="$router.push('/joins?classifyId=1')">
      <el-image class="icon" :src="require('@/assets/layout/woyaojiameng.png')"></el-image>
      <span>我要加盟</span>
    </div>
  </div>
</template>

<script>
import { getWebsiteConfig } from "@/utils/website-config";

export default {
  name: "FloatBtnGroup",
  computed: {
    websiteConfig () {
      return getWebsiteConfig()
    }
  }
}
</script>

<style scoped lang="scss">
.float-btn-group {
  position: fixed;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  box-shadow: 0 2px 6px rgba(136, 147, 169, 0.26);
  border: 1px solid #D7D7D7;
  z-index: 1000;

  .btn-item {
    position: relative;
    width: 96px;
    height: 92px;
    background-color: #FFFFFF;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    a {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-decoration: none;
    }

    &:hover {
      .icon, span {
        transform: scale(1.1);
      }
    }

    &.btn1:hover {
      .phone {
        display: block;
      }
    }

    .phone {
      position: absolute;
      width: 140px;
      height: 46px;
      left: -145px;
      z-index: 1;
      top: 25%;
      background-color: #FFFFFF;
      color: #2D2D2D;
      display: none;
      font-size: 18px;
      font-weight: bold;
      line-height: 46px;
      text-align: center;
      box-shadow: 0 2px 6px rgba(136, 147, 169, 0.26);

      a {
        color: #2D2D2D;
        text-decoration: none;
      }
    }

    &.btn2:hover {
      .qrcode {
        display: block;
      }
    }

    .qrcode {
      position: absolute;
      width: 140px;
      height: 140px;
      left: -145px;
      z-index: 1;
      box-shadow: 0 2px 6px rgba(136, 147, 169, 0.26);
      display: none;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }

    .icon, span {
      transition: all .3s;
    }

    .icon {
      width: 32px;
      height: 32px;
    }

    span {
      color: #6C6C6C;
      font-weight: bold;
      font-size: 14px;
    }
  }
}
</style>